module.exports = __webpack_public_path__ + "img/lg_ring_y_s_1_1.2abba241.png";